import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { CakeToOrderPortionModel } from 'entities';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { CakeToOrderPageMainPortionCard } from './CakeToOrderPageMainPortionCard';

export type CakeToOrderPageMainPortionPickerProps = {
    cakeToOrderPortions: CakeToOrderPortionModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const CakeToOrderPageMainPortionPicker
: React.FC<CakeToOrderPageMainPortionPickerProps> = ({
    cakeToOrderPortions,
    ...restProps
}) => (
    <Grid gap="2rem" {...restProps}>
        <Grid
            gap="2rem"
            width="100%"
        >
            {
                cakeToOrderPortions?.map(({
                    value,
                    meassure,
                    description,
                    weight,
                    price,
                    currency,
                    pricePrefix,
                }) => (
                    <CakeToOrderPageMainPortionCard
                        width="100%"
                        value={value}
                        measure={meassure.toLocaleUpperCase()}
                        pricePrefix={pricePrefix}
                        description={description}
                        weight={weight}
                        price={price}
                        currency={currency?.abbreviation}
                        isActive={false}
                    />
                ))
            }
        </Grid>

    </Grid>
);
